<template>
  <a-form :model="form" layout="vertical" class="ml-5 mt-10">
    <a-row :gutter="20">
      <a-col :span="10">
        <a-form-item label="Name">
          <a-input v-model:value="form.name" placeholder="Name" />
        </a-form-item>
      </a-col>
      <a-col :span="10">
        <a-form-item label="Period">
          <a-input v-model:value="form.period" readonly placeholder="Period" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="10">
        <a-form-item label="Price">
          <a-input v-model:value="form.price" placeholder="Price" />
        </a-form-item>
      </a-col>
      <a-col :span="5">
        <a-form-item label="Discounted Price">
          <a-input
            v-model:value="form.discounted_price"
            placeholder="Discounted Price"
          />
        </a-form-item>
      </a-col>

      <a-col :span="5">
        <div>
          <a-form-item label="Use disounte price">
            <Switch v-model="form.use_discount" />
          </a-form-item>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="10">
        <a-form-item label="Extras">
          <a-input v-model:value="form.extras" placeholder="Extras" />
        </a-form-item>
      </a-col>
      <a-col :span="10">
        <a-form-item label="Paddle Plan Id">
          <a-input
            v-model:value="form.paddle_plan_id"
            placeholder="Paddle Plan Id"
          />
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="20">
        <a-form-item label="Features">
          <a-textarea
            v-model:value="form.features"
            placeholder="Features"
            :rows="10"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import Switch from "@/components/UI/Switch.vue";
export default {
  components: { Switch },
  props: {
    modelValue: Object,
  },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
    };
  },
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },
  },
};
</script>

<style></style>
